<template>
    <div class="card mt-3">
        <div class="card-header bg-success">
            <span style="color: white">Холат</span>
        </div>
        <div class="card-body">
            <ul class="list-group list-group-flush overflow-auto" style="max-height: 300px">
                <li class="list-group-item text-center">
                    <div class="badge badge-secondary" v-if="fitment.appraisalStatusEnum==='AssignedToEvaluator'">{{$t("realEstate.status.assignedToEvaluator")}}</div>
                    <div class="badge badge-warning" v-else-if="fitment.appraisalStatusEnum==='NotFullyEvaluated'">{{$t("realEstate.status.notFullyEvaluated")}}</div>
                    <div class="badge badge-info" v-else-if="fitment.appraisalStatusEnum==='Rated'">{{$t("realEstate.status.evaluated")}}</div>
                    <div class="badge badge-success" v-else-if="fitment.appraisalStatusEnum==='Confirmed'">{{$t("realEstate.status.confirmed")}}</div>
                    <div class="badge badge-danger" v-else-if="fitment.appraisalStatusEnum==='Rejected'">{{$t("realEstate.status.rejected")}}</div>
                    <div class="badge badge-success" v-else-if="fitment.appraisalStatusEnum==='InIdentification'">{{$t("realEstate.status.inIdentification")}}</div>
                    <div class="badge badge-danger" v-else>{{$t("realEstate.status.pending")}}</div>
                    <div v-if="fitment.appraisalStatusEnum==='Confirmed'">Сана: {{new Date(fitment.confirmedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="fitment.appraiserReportEsp">Баҳоловчи тамонидан ҳисобот (ЭЦП орқали)
                      <span class="badge badge-info"> Тасдиқланган</span>
                      <span class="badge badge-info"> {{ fitment.appraiserReportEsp.espSignData }}</span>
                    </div>
                    <div v-else>Баҳоловчи тамонидан ҳисобот (ЭЦП орқали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="fitment.directorActInvoiceEsp">Директор тамонидан Ҳисоб варак фактура (ЭЦП оркали)
                      <span class="badge badge-info"> Тасдиқланган</span>
                      <span class="badge badge-info"> {{ fitment.directorActInvoiceEsp.espSignData }}</span>
                    </div>
                    <div v-else>Директор тамонидан Ҳисоб варак фактура (ЭЦП орқали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center">
                    <div v-if="fitment.directorReportEsp">Директор тамонидан ҳисобот (ЭЦП орқали)
                      <span class="badge badge-info"> Тасдиқланган</span>
                      <span class="badge badge-info"> {{ fitment.directorReportEsp.espSignData }}</span>
                    </div>
                    <div v-else>Директор тамонидан ҳисобот (ЭЦП оркали) <span class="badge badge-warning"> Тасдиқланмаган</span></div>
                </li>
                <li class="list-group-item text-center" v-if="fitment.invoiceMib">
                    <span class="badge badge-success" v-if="fitment.invoiceMib.invoiceMIbJsonDirector">{{fitment.invoiceMib.invoiceMIbJsonDirector}}</span>
                    <span class="badge badge-success" v-if="fitment.invoiceMib.invoiceMIbJsonClient">{{fitment.invoiceMib.invoiceMIbJsonClient}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            fitment: Object
        }
    }
</script>

<style scoped>

</style>